import * as React from 'react';

import IconProps from 'packages/kakapo-ui-kit/assets/icons/IconProps';

function ListViewIcon(props: IconProps) {
	const { color } = props;

	return (
		<svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M14.858 16.001h-4.572a1.143 1.143 0 01-1.143-1.143v-4.572c0-.63.512-1.143 1.143-1.143h4.572c.631 0 1.143.512 1.143 1.143v4.572c0 .631-.512 1.143-1.143 1.143zm0-5.143a.572.572 0 00-.571-.572h-3.43a.572.572 0 00-.57.572v3.429c0 .315.255.57.57.57h3.43a.57.57 0 00.57-.57v-3.43zm0-4h-4.572a1.143 1.143 0 01-1.143-1.143V1.144C9.143.512 9.655 0 10.286 0h4.572C15.489 0 16 .512 16 1.144v4.571c0 .631-.512 1.143-1.143 1.143zm0-5.144a.57.57 0 00-.571-.57h-3.43a.57.57 0 00-.57.57v3.43c0 .315.255.571.57.571h3.43a.572.572 0 00.57-.571v-3.43zM5.715 16.001H1.143A1.143 1.143 0 010 14.858v-4.572c0-.63.512-1.143 1.143-1.143h4.572c.631 0 1.142.512 1.142 1.143v4.572c0 .631-.511 1.143-1.142 1.143zm0-5.143a.572.572 0 00-.572-.572H1.714a.572.572 0 00-.571.572v3.429c0 .315.256.57.571.57h3.43a.571.571 0 00.57-.57v-3.43zm0-4H1.143A1.143 1.143 0 010 5.715V1.144C0 .512.512 0 1.143 0h4.572c.631 0 1.142.512 1.142 1.144v4.571c0 .631-.511 1.143-1.142 1.143zm0-5.144a.57.57 0 00-.572-.57H1.714a.57.57 0 00-.571.57v3.43c0 .315.256.571.571.571h3.43a.572.572 0 00.57-.571v-3.43z"
				fill={color ?? '#6C7680'}
				fillRule="nonzero"
			/>
		</svg>
	);
}

export default ListViewIcon;
